import { render } from "./settings_property_tab.html?vue&type=template&id=651f79ff&external"
import script from "./settings_property_tab.js?vue&type=script&lang=js&external"
export * from "./settings_property_tab.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__